import axios from "axios";
import { toast } from "sonner";
import { Buffer } from "buffer";

import {
  clearUserDetailsFromDB,
  getUserDetailsFromDB,
  storeUserDetails,
} from "../utils/databaseConfig";
import { globalRouter } from "../utils/common";
import { triggerFetchUser } from "../context/AuthProvider";
import { extractErrorMessage } from "../utils/utils";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const userData = await getUserDetailsFromDB();
    if (userData?.data?.accessToken) {
      config.headers["Authorization"] = `Bearer ${userData?.data?.accessToken}`;
    }

    if (process.env.REACT_APP_IS_ENCODED === "true") {
      //encode the request body
      if (config.data) {
        config.data = Buffer.from(JSON.stringify(config.data)).toString(
          "base64"
        );
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  async (response) => {
    if (process.env.REACT_APP_IS_ENCODED === "true" && response?.data) {
      try {
        // Decode  response
        const decodedData = JSON.parse(
          JSON.parse(Buffer.from(response.data, "base64").toString("utf8"))
        );
        console.log("Decoded response for loginnnnn", decodedData);

        return decodedData;
      } catch (err) {
        console.error("Error decoding Base64 response:", err);
      }
    }

    return response?.data;
  },
  async (error) => {
    if (process.env.REACT_APP_IS_ENCODED === "true" && error?.response?.data) {
      try {
        // Decode error response data
        const encodedErrorData = error.response.data;
        error.response.data = JSON.parse(
          JSON.parse(Buffer.from(encodedErrorData, "base64").toString("utf8"))
        );

        // Replace error response data with decoded data
      } catch (decodeError) {
        console.error("Error decoding Base64 error:", decodeError);
      }
    }
    const userData = await getUserDetailsFromDB();

    if (
      (error?.response?.status === 403 || error?.response?.status === 401) &&
      userData?.data?.refreshToken
    ) {
      try {
        const refreshRes = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/auth/refreshAccess`,
          {},
          {
            headers: {
              Authorization: `Bearer ${userData?.data?.refreshToken}`,
            },
          }
        );
        const updatedData = {
          ...userData,
          data: {
            ...userData.data,
            accessToken: refreshRes?.data?.data?.accessToken,
          },
        };
        await storeUserDetails(updatedData);
        triggerFetchUser();
        error.config.headers[
          "Authorization"
        ] = `Bearer ${refreshRes?.data?.data?.accessToken}`;
        return axiosInstance.request(error.config);
      } catch (refreshError) {
        globalRouter.navigate && globalRouter.navigate("/", { replace: true });
        await clearUserDetailsFromDB();
        return Promise.reject(refreshError);
      }
    }
    const errorMessage = extractErrorMessage(error);

    toast.error(errorMessage);

    return Promise.reject(error);
  }
);
